import { Tour, TourType } from '@/_models/Tour';

export enum ShareMethod {
  Facebook = 'facebook',
  Whatsapp = 'whatsapp',
  Mail = 'mail',
  Twitter = 'twitter',
  Clipboard = 'clipboard',
}

export type Props = {
  closeOnOutsideClick?: boolean;
  getLocation?: () => string;
  onClose: () => void;
  tour?: Tour & { client?: { fbAppId?: string }; user?: { fbAppId?: string } };
  translation: any;
  onColor?: string;
  link?: string;
  tourType?: TourType;
  hideShareLocation?: boolean;
};
